import React, { useEffect, useState } from 'react'
import AccountSidebar from '../../components/AccountSidebar';
import { toast } from 'react-hot-toast';
import Header from '../../components/Header';
import Footer from '../../components/Footer';
import { Link, useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import { useBlogContext } from '../../../fetchdata/BlogContext';
import NavBar from '../../components/NavBar';
import HeaderPage from '../../components/HeaderPage';
import getDecryptData from '../../../helper/getDecryptData';
import axiosInstance from '../../../axiosInstance';

const AccountWallet = () => {

  const decryptdatajson = getDecryptData();

  const { dataAuth, IsUserData } = useBlogContext();

  const [Loading, setLoading] = useState(true);
  const [SubmitLoading, setSubmitLoading] = useState(true); // Add loading state
  const [Transaction, setTransaction] = useState([]);

  const formatDate = (dateString) => {
    const options = { year: "numeric", month: "long", day: "numeric" };
    return new Date(dateString).toLocaleDateString(undefined, options);
  };

  const formatTime = (dateString) => {
    const options = { hour: "2-digit", minute: "2-digit" };
    return new Date(dateString).toLocaleTimeString(undefined, options);
  };

  const [sortOrder, setSortOrder] = useState(1); // 1 for Newest, 2 for Oldest
  const [filterRange, setFilterRange] = useState("all"); // 'all', 'today', '7days', '1month'

  const handleSortChange = (event) => {
    setSortOrder(parseInt(event.target.value));
  };

  const handleFilterChange = (event) => {
    setFilterRange(event.target.value);
  };

  const [formData, setFormData] = useState({
    userId: null,
    type: 0,
    note: `Add Funds By ${decryptdatajson.username} `,
    amount: 0,
    wallet: 0,
    trans: 0,
  });

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  //form handle

  const fetchtransactionById = async () => {
    const decryptdatajson = await getDecryptData();

    const id = decryptdatajson._id;

    try {
      setLoading(true);

      const { data } = await axiosInstance.get(`/all-transaction/${id}`);
      const { success } = data;

      if (success) {
        setTransaction(data.transactions.reverse());
      }
    } catch (error) {
      console.error("Error during login:", error);
      // Handle network errors, API issues, etc.
      toast.error(error.response.data.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchtransactionById();
    dataAuth();
  }, []);

  useEffect(() => {
    if (formData.trans) {
      setTransaction(Transaction.reverse());
      console.log("formData.trans", formData.trans);
    }
  }, [formData.trans]);


  return (
    <>

      <HeaderPage title={'My Wallet'} />
      <main className="page-content mypadding overflow-auto pb-4 px-0" >


        {!Loading ? (
          <>
            <div className="container">
              <div className="rewards-box">
                <h5 className="sub-title">
                  My Funds
                  <span className="icon-bx">
                    <i className="feather icon-info" />
                  </span>
                </h5>
                <h2 className="title">
                  {SubmitLoading ? (
                    IsUserData.wallet
                  ) : (
                    <>
                      <div className="bg-white rounded">
                        <div
                          className="skeleton m-auto"
                          style={{ height: 80, width: "100%" }}
                        />
                      </div>
                    </>
                  )}
                </h2>


                <div className="bg-icon">
                  <img src="assets/images/svg/rewards.svg" alt="images" />
                </div>
              </div>
              <div className="title-bar">
                <h5 className="title">All Transaction</h5>

              </div>
              <div className="rewards-list">
                <ul>
                  {Transaction.map((transaction) => (
                    <li key={transaction._id}>
                      <div className="item-head">
                        <h6 className="title">
                          <span
                            className={`${transaction?.type === 1 && "text-danger "
                              }`}
                          >
                            {" "}
                            {transaction?.note}{" "}
                          </span>
                        </h6>
                        <div className="dz-meta">
                          <ul>
                            <li>{formatDate(transaction?.createdAt)}</li>
                            <li>{formatTime(transaction?.createdAt)}</li>
                          </ul>
                        </div>
                      </div>
                      <div className="pts-bx">
                        <h4
                          className={`points text-${transaction.type !== 1 ? "primary" : "danger"
                            }`}
                        >
                          {transaction.amount >= 0 ? "+" : "-"}
                          {Math.abs(transaction.amount)}
                        </h4>

                        <p>Funds</p>
                      </div>
                    </li>
                  ))}
                </ul>
              </div>
            </div>

            <br /> <br /> <br />
          </>
        ) : (
          <>
            <div className="container pt-0">
              <div
                className="skeleton mb-4 me-4"
                style={{ height: 197, width: "100%" }}
              />
              <div
                className="skeleton m-auto mb-4"
                style={{ height: 80, width: "100%" }}
              />
              <div
                className="skeleton m-auto mb-4"
                style={{ height: 80, width: "100%" }}
              />
              <div
                className="skeleton m-auto mb-4"
                style={{ height: 80, width: "100%" }}
              />
              <div
                className="skeleton m-auto mb-4"
                style={{ height: 80, width: "100%" }}
              />
              <br /> <br /> <br />
            </div>
          </>
        )}



        <NavBar />

      </main>
    </>
  )
}

export default AccountWallet